import type { ScreenModule } from "../../../app/screen-module";
import { ContactsPage } from "../pages";

export default {
	id: "system-admin.contacts",
	path: "/system/contacts",
	area: "system-admin",
	navGroup: "コンテンツ",
	label: "問い合わせ",
	roles: ["platform_admin", "platform_viewer"],
	backing: "MOCK_ONLY",
	enabled: true,
	component: ContactsPage,
} satisfies ScreenModule;
